module.exports = __webpack_public_path__ + "img/chevron-bar-down.23f8290d.svg";